import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="w-full py-12 md:py-24 lg:py-32 bg-gradient-to-br from-sage-600 to-navy-500" data-id="element-75">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-76">
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-12 items-center" data-id="element-77">
          <div className="flex flex-col justify-center space-y-4 text-center lg:text-left" data-id="element-78">
            <div className="space-y-2" data-id="element-79">
              <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl/none text-white" data-id="element-80">
                Quit Coffee. Stay Focused. Feel Human Again.
              </h1>
              <p className="mx-auto max-w-[700px] text-white md:text-xl lg:text-2xl" data-id="element-81">
                Ditch caffeine crashes. Build clean, calm energy in 2 weeks—with
                FocusFlow.
              </p>
            </div>
            <p className="mx-auto max-w-[700px] text-white/80 md:text-lg lg:mx-0" data-id="element-82">
              POV: You're 27, drink 4 cups of coffee daily, and still can't hit
              your goals. The millennial founder who realized his coffee
              addiction was sabotaging his success—and built the morning routine
              that 10x'd his productivity.
            </p>
            <div className="flex flex-col gap-3 min-[400px]:flex-row justify-center lg:justify-start" data-id="element-83">
              <a href="https://shop.focusflowblend.com/products/focus-flow-starter-pack" className="inline-flex h-12 items-center justify-center rounded-md bg-white px-6 font-medium text-sage-700 shadow transition-colors hover:bg-white/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white" data-id="element-84">
                CLAIM MY STARTER PACK
                <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-85" />
              </a>
            </div>
            <div className="text-xs text-white/60 mt-2" data-id="element-86">
              Posted by Alex Chen •{' '}
              {new Date().toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })}
            </div>
          </div>
          <div className="mx-auto lg:mr-0 flex items-center justify-center" data-id="element-87">
            <div className="relative h-[350px] w-[300px] overflow-hidden rounded-xl bg-white/10 backdrop-blur-sm shadow-xl" data-id="element-88">
              <img src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80" alt="Stressed man with laptop" className="absolute inset-0 object-cover w-full h-full" data-id="element-89" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}